// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060406/js/" + chunkId + "." + {"44":"61a977f4","225":"9cc38cd2","481":"dbc61002","486":"c7be519f","770":"57ad2ab9"}[chunkId] + ".0.8878364407208122.chunk.js";
};